var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.recipient),expression:"recipient"}],staticClass:"full_width",staticStyle:{"text-align":"left","direction":"ltr !important"},domProps:{"value":(_vm.recipient)},on:{"input":function($event){if($event.target.composing)return;_vm.recipient=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }